var exports = {
  "In": "TextualAttachmentPreview.module__textualPreview___WDl2ME",
  "KR": "TextualAttachmentPreview.module__previewSurface___WDl2ME",
  "cA": "TextualAttachmentPreview.module__previewActions___WDl2ME",
  "wL": "TextualAttachmentPreview.module__previewActionsVisible___WDl2ME",
  "VA": "TextualAttachmentPreview.module__previewActionButton___WDl2ME" + " " + __webpack_require__(180357)["AS"],
  "nJ": "TextualAttachmentPreview.module__copyIcon___WDl2ME",
  "fs": "TextualAttachmentPreview.module__inlinePreviewSurface___WDl2ME",
  "vd": "TextualAttachmentPreview.module__previewViewport___WDl2ME",
  "uL": "TextualAttachmentPreview.module__previewViewportCollapsed___WDl2ME",
  "q4": "TextualAttachmentPreview.module__previewViewportExpanded___WDl2ME",
  "Nv": "TextualAttachmentPreview.module__csvTableViewport___WDl2ME",
  "rV": "TextualAttachmentPreview.module__csvTableMarkup___WDl2ME",
  "uT": "TextualAttachmentPreview.module__previewCode___WDl2ME",
  "O9": "TextualAttachmentPreview.module__previewCodeWrap___WDl2ME",
  "VP": "TextualAttachmentPreview.module__previewError___WDl2ME",
  "Ml": "TextualAttachmentPreview.module__loadingState___WDl2ME",
  "qr": "TextualAttachmentPreview.module__footer___WDl2ME",
  "X1": "TextualAttachmentPreview.module__expandButton___WDl2ME" + " " + __webpack_require__(180357)["AS"],
  "eO": "TextualAttachmentPreview.module__expandIcon___WDl2ME",
  "t2": "TextualAttachmentPreview.module__expandIconExpanded___WDl2ME",
  "qt": "TextualAttachmentPreview.module__fileSection___WDl2ME",
  "gM": "TextualAttachmentPreview.module__fileMeta___WDl2ME",
  "Md": "TextualAttachmentPreview.module__fileName___WDl2ME",
  "Ov": "TextualAttachmentPreview.module__fileSize___WDl2ME",
  "zt": "TextualAttachmentPreview.module__footerActions___WDl2ME",
  "uH": "TextualAttachmentPreview.module__controlButton___WDl2ME" + " " + __webpack_require__(180357)["AS"],
  "RJ": "TextualAttachmentPreview.module__languagePositioner___WDl2ME",
  "tP": "TextualAttachmentPreview.module__languagePopup___WDl2ME",
  "Nl": "TextualAttachmentPreview.module__languageSearchWrap___WDl2ME",
  "nb": "TextualAttachmentPreview.module__languageSearchInput___WDl2ME",
  "qm": "TextualAttachmentPreview.module__languageEmpty___WDl2ME",
  "xl": "TextualAttachmentPreview.module__languageList___WDl2ME",
  "O6": "TextualAttachmentPreview.module__languageItem___WDl2ME",
  "d6": "TextualAttachmentPreview.module__languageItemHighlighted___WDl2ME",
  "J6": "TextualAttachmentPreview.module__languageItemSelected___WDl2ME",
  "xu": "TextualAttachmentPreview.module__languageItemIndicator___WDl2ME",
  "lh": "TextualAttachmentPreview.module__languageOptionContent___WDl2ME",
  "XO": "TextualAttachmentPreview.module__languageOptionCode___WDl2ME",
  "_s": "TextualAttachmentPreview.module__languageOptionCanonical___WDl2ME",
  "CR": "TextualAttachmentPreview.module__modalRoot___WDl2ME",
  "Ij": "TextualAttachmentPreview.module__modalLayout___WDl2ME",
  "S3": "TextualAttachmentPreview.module__modalBody___WDl2ME",
  "fn": "TextualAttachmentPreview.module__modalPreviewSurface___WDl2ME",
  "CM": "TextualAttachmentPreview.module__previewViewportFill___WDl2ME",
  "v6": "TextualAttachmentPreview.module__previewCodeFill___WDl2ME",
};

module.exports = exports;
